module.exports = __webpack_public_path__ + "img/ic_shouqi.09a019f4.svg";